<template>
  <div>
    <other-banner :BannerType="'新闻中心'"></other-banner>
    <div class="content_box">
      <div class="cutr_content">
        <div class="crumbs"><span style="color: #666666" @click="$router.push('/news')">当前位置：新闻中心></span> {{ newDetail.title }}</div>
        <div class="info_box">
          <div class="names">{{ newDetail.title }}</div>
          <div class="times">{{ newDetail.create_time }}</div>
          <div class="html_box" v-html="newDetail.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OtherBanner from "../components/otherBanner";
import {getNewsInfo} from "../api/apis";

export default {
  name: "product",
  components: {OtherBanner},
  data(){
    return{
      newDetail:{},
      detailsId:''
    }
  },
  mounted() {
    if(this.$route.query.detaisId){
      this.detailsId = this.$route.query.detaisId
    }
    this.GetNewsInfo()
  },
  methods:{
    GetNewsInfo(){
      let datas = {id:this.detailsId}
      getNewsInfo(datas).then(res=>{
        res.data.text = res.data.text.replace(/\<img/gi, '<img style="max-width:100%;height:auto"')
        this.newDetail = res.data
      })
    }
  }

}
</script>

<style scoped lang="less">
.content_box{
  width: 1200px;
  margin: 0 auto;
  cursor: pointer;
  .cutr_content {
    cursor: pointer;
    margin-top: 50px;
    .crumbs{
      padding:0 0 15px;
      border-bottom: 1px solid #DBDBDB;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #0092DD;
      opacity: 1;
    }
    .info_box{
       margin-top: 82px;
      .names{
        font-size: 28px;
        font-family: MicrosoftYaHei;
        color: #333333;
        text-align: center;
      }
      .times{
        font-size: 20px;
        font-family: Segoe UI;
        font-weight: 400;
        color: #707070;
        text-align: center;
        margin: 20px auto 60px;
      }
      .html_box{
        font-size: 17px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 32px;
        color: #666666;
        p{
          overflow: hidden;
        }
      }
    }
  }
}
@media (max-width: 1200px) {
  .content_box{
    width: auto;
    padding:0.1px 15px 0;
    .cutr_content {
      margin-top: 21px;
      .crumbs{
        padding:0 0 15px;
        border-bottom: 1px solid #DBDBDB;
        font-size: 10px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #0092DD;
        opacity: 1;
      }
      .info_box{
        margin-top: 25px;
        .names{
          font-size: 14px;
        }
        .times{
          font-size: 10px;
          margin: 10px auto 17px;
        }
        .html_box{
          font-size: 13px;
        }
      }
    }
  }
}
</style>
<style lang="less">
.html_box p{
  overflow: hidden !important;
}
</style>